import { createFileRoute } from '@tanstack/react-router';

import { GeneralPage } from '@/features/setting/page/general-page';

export const Route = createFileRoute('/workspace/$workspaceId/settings/general')({
  component: RouteComponent,
});

function RouteComponent() {
  return <GeneralPage />;
}
